/** Señal ligera para refrescar POS/Caja tras open/close sin depender solo de navigation focus. */
let changeVersion = 0;
const listeners = new Set<() => void>();

export function bumpCashSessionChangeSignal(): void {
  changeVersion += 1;
  listeners.forEach((listener) => listener());
}

export function subscribeCashSessionChangeSignal(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Igual que subscribe, con debounce trailing (Caja/Gastos; POS mantiene sync). */
export function subscribeCashSessionChangeSignalDebounced(
  listener: () => void,
  debounceMs = 400
): () => void {
  let timer: ReturnType<typeof setTimeout> | null = null;
  const debounced = () => {
    if (timer != null) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      listener();
    }, debounceMs);
  };
  const unsubscribe = subscribeCashSessionChangeSignal(debounced);
  return () => {
    if (timer != null) clearTimeout(timer);
    unsubscribe();
  };
}
